// Image Gallery List 1
import gallery1Img1 from '../assets/images/case-study/case-study-img1.webp';
import gallery1Img2 from '../assets/images/case-study/case-study-img2.webp';
import gallery1Img3 from '../assets/images/case-study/case-study-img3.webp';
import gallery1Img4 from '../assets/images/case-study/case-study-img4.webp';
import gallery1Img5 from '../assets/images/case-study/case-study-img5.webp';
import gallery1Img6 from '../assets/images/case-study/case-study-img6.webp';
import gallery1Img7 from '../assets/images/case-study/case-study-img7.webp';
import gallery1Img8 from '../assets/images/case-study/case-study-img8.webp';
import gallery1Img9 from '../assets/images/case-study/case-study-img9.webp';
import gallery1Img10 from '../assets/images/case-study/case-study-img10.webp';
import gallery1Img11 from '../assets/images/case-study/case-study-img11.webp';
import gallery1Img12 from '../assets/images/case-study/case-study-img12.webp';

// Image Gallery List 2
import gallery2Img1 from '../assets/images/gallery/01.webp';
import gallery2Img2 from '../assets/images/gallery/02.webp';
import gallery2Img3 from '../assets/images/gallery/03.webp';
import gallery2Img4 from '../assets/images/gallery/04.webp';
import gallery2Img5 from '../assets/images/gallery/05.webp';
import gallery2Img6 from '../assets/images/gallery/06.webp';
import gallery2Img7 from '../assets/images/gallery/07.webp';
import gallery2Img8 from '../assets/images/gallery/08.webp';

const ImageGalleryList = [
  {
    id: 1,
    imgsrc: gallery1Img1,
    title: 'Car Dealer',
    category: 'Automotive',
  },
  {
    id: 2,
    imgsrc: gallery1Img2,
    title: 'Gozzby',
    category: 'Music',
  },
  {
    id: 3,
    imgsrc: gallery1Img3,
    title: 'The Sports Space',
    category: 'Sport',
  },
  {
    id: 4,
    imgsrc: gallery1Img4,
    title: 'Educatgenix',
    category: 'Education',
  },
  {
    id: 5,
    imgsrc: gallery1Img5,
    title: 'Financeoont',
    category: 'Finance',
  },
  {
    id: 6,
    imgsrc: gallery1Img6,
    title: 'Petfluent',
    category: 'Pet Care',
  },
  {
    id: 7,
    imgsrc: gallery1Img7,
    title: 'Transportwind',
    category: 'Transport',
  },
  {
    id: 8,
    imgsrc: gallery1Img8,
    title: 'Travelomatic',
    category: 'Traveling',
  },
  {
    id: 9,
    imgsrc: gallery1Img9,
    title: 'Mobifluent',
    category: 'Mobile',
  },
  {
    id: 10,
    imgsrc: gallery1Img10,
    title: 'Foodocity',
    category: 'Food',
  },
  {
    id: 11,
    imgsrc: gallery1Img11,
    title: 'Dentzoid',
    category: 'Dental',
  },
  {
    id: 12,
    imgsrc: gallery1Img12,
    title: 'Healthque',
    category: 'Health',
  },
];

const ImageGalleryList2 = [
  {
    id: 1,
    imgsrc: gallery2Img1,
  },
  {
    id: 2,
    imgsrc: gallery2Img2,
  },
  {
    id: 3,
    imgsrc: gallery2Img3,
  },
  {
    id: 4,
    imgsrc: gallery2Img4,
  },
  {
    id: 5,
    imgsrc: gallery2Img5,
  },
  {
    id: 6,
    imgsrc: gallery2Img6,
  },
  {
    id: 7,
    imgsrc: gallery2Img7,
  },
  {
    id: 8,
    imgsrc: gallery2Img8,
  },
];

export default ImageGalleryList;
export { ImageGalleryList2 };
